import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { NetworkCallService } from 'src/app/core/services/network-call.service';
import { concat, of } from 'rxjs';
import { catchError, concatMap, debounceTime, flatMap, map, mergeMap, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import * as validate from '../actions/validate-gov-id-passport.actions';
import { IValidateGovIdPassortRequest, IValidateGovIdPassortResponse } from '../models/validate-gov-id-passport.model';

@Injectable()
export class ValidateGivIdPassportEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helpers: HelpersService
  ) {}

  validateGovId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(validate.loadValidateGovIdPassports),
      switchMap(action =>
        this.networkCallService
          .post<
            IValidateGovIdPassortRequest,
            IValidateGovIdPassortResponse
          >('Authentication/validateGovernmentIdOrPassportNumber', action.request)
          .pipe(
            debounceTime(1000),
            map(response => {
              return validate.loadValidateGovIdPassportsSuccess({ response });
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(validate.loadValidateGovIdPassportsFailure(error));
            })
          )
      )
    )
  );
}
